import React from 'react';
import './WhatIDo.css';

const WhatIDo = () => {
  const skills = [
    {
      title: 'Design Thinking',
      description: 'I approach challenges with an open, problem-solving mindset, using design thinking to move from messy ambiguity to meaningful solutions. It\'s how I stay creative and grounded.'
    },
    {
      title: 'UX/UI Design',
      description: 'I design digital experiences that are both intuitive and visually engaging. My frontend web development skills help me bridge the gap between design and dev, making collaboration smoother and more efficient.'
    },
    {
      title: 'User-Centered Design',
      description: ' People come first in everything I make. I focus on understanding real needs, behaviours, and pain points to create experiences that actually work for the humans behind the screen.'
    },
    {
      title: 'Design Research',
      description: 'I believe good design starts with listening. Through research and testing, I gather insights that shape smarter, more empathetic decisions — and I never design in a vacuum.'
    }
  ];

  return (
    <section id="what-i-do" className="what-i-do-section">
      <div className="what-i-do-container">
        <div className="what-i-do-header">
          <h2 className="section-title">WHAT I DO BEST</h2>
        </div>
        
        <div className="stack">
          {skills.map((skill, index) => (
            <div className="stack__item" key={index}>
              <div className="stack__item__title">
                <p>{skill.title}</p>
              </div>
              <div className="stack__item__description">
                <span>{skill.description}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatIDo; 